{
  "dateFormats": {
    "long": "dd 'de' MMMM 'de' yyyy",
    "short": "dd/MM/yyyy"
  },
  "card": {
    "badge": "Certificado",
    "code": "Código:",
    "issuedAt": "Emitido em:",
    "completedAt": "Concluído em:",
    "completed": "Concluído",
    "view": "Visualizar",
    "downloading": "Baixando...",
    "download": "Download"
  },
  "viewer": {
    "title": "Certificado de Conclusão",
    "description": "Visualização do certificado",
    "student": "Estudante",
    "code": "Código",
    "issueDate": "Data de Emissão",
    "status": "Status",
    "valid": "Válido",
    "loading": "Carregando certificado...",
    "previewTitle": "Visualização do Certificado",
    "validNotice": "Certificado válido e verificável através do código acima",
    "openNewTab": "Abrir em Nova Aba",
    "downloading": "Baixando...",
    "downloadPdf": "Download PDF"
  },
  "generator": {
    "title": "CERTIFICADO DE CONCLUSÃO",
    "subtitle": "Xtreed - Plataforma de Ensino",
    "certifyThat": "Certificamos que",
    "completedCourse": "concluiu com êxito o curso",
    "dedication": "demonstrando conhecimento e dedicação nos estudos",
    "completionDate": "Data de Conclusão",
    "verificationCode": "Código de Verificação",
    "generatingCode": "Gerando...",
    "platform": "Plataforma",
    "validNotice": "Este certificado é válido e pode ser verificado através do código acima.",
    "copyright": "© {{year}} Xtreed. Todos os direitos reservados.",
    "generating": "Gerando Certificado...",
    "generate": "Gerar Certificado",
    "generated": "Certificado Gerado",
    "downloading": "Baixando...",
    "downloadPdf": "Download PDF"
  },
  "service": {
    "qrCodeError": "Falha ao gerar QR Code",
    "linkedInCopy": {
      "module": {
        "title": "🎓 Módulo Concluído: {{title}}",
        "description": "Acabei de concluir o módulo \"{{title}}\" na Xtreed! Mais um passo na minha jornada de desenvolvimento profissional. 💻✨",
        "hashtags": "#Xtreed #Programação #Desenvolvimento #Aprendizado #TechEducation"
      },
      "course": {
        "title": "🏆 Curso Completo: {{title}}",
        "description": "Certificado conquistado! Concluí com sucesso o curso \"{{title}}\" na Xtreed. Conhecimento adquirido e pronto para novos desafios! 🚀",
        "hashtags": "#Xtreed #CertificadoProfissional #Programação #TechSkills #CarreiraTech"
      },
      "track": {
        "title": "🎯 Trilha Completa: {{title}}",
        "description": "Missão cumprida! Finalizei toda a trilha \"{{title}}\" na Xtreed. Uma jornada completa de aprendizado e crescimento profissional! 🌟",
        "hashtags": "#Xtreed #TrilhaCompleta #FullStack #DesenvolvedorProfissional #TechCareer"
      }
    }
  },
  "blockchainVerifier": {
    "toasts": {
      "enterHash": "Digite o hash da transação",
      "verifiedTitle": "Certificado verificado na blockchain!",
      "verifiedDescription": "Documento autêntico e imutável",
      "notFoundTitle": "Hash não encontrado na blockchain",
      "notFoundDescription": "Verifique se o hash está correto",
      "verifiedDemo": "Certificado verificado na blockchain! (DEMO)",
      "hashCopied": "Hash copiado!"
    },
    "networkStats": {
      "status": {
        "online": "online",
        "delayed": "atrasada",
        "offline": "offline"
      },
      "certificates": "Certificados",
      "transactions": "Transações",
      "lastBlock": "Último Bloco",
      "averageGas": "Gas Médio"
    },
    "header": {
      "title": "Verificação Blockchain",
      "description": "Verifique a autenticidade de certificados Xtreed na blockchain. Registros imutáveis garantem máxima segurança e confiabilidade."
    },
    "form": {
      "title": "Verificar Hash da Transação",
      "description": "Digite o hash da transação blockchain para verificar um certificado",
      "hashLabel": "Hash da Transação",
      "supported": "Suportado: Ethereum e Polygon • Verificação em tempo real"
    },
    "result": {
      "validTitle": "Certificado Verificado na Blockchain ✓",
      "invalidTitle": "Hash Não Encontrado ✗",
      "validDescription": "Registro encontrado na blockchain - documento autêntico e imutável",
      "invalidDescription": "Não foi possível encontrar este hash na blockchain",
      "verifiedAt": "Verificado em {{date}}",
      "block": "Bloco #{{block}}",
      "confirmations_one": "{{count}} confirmação",
      "confirmations_zero": "{{count}} confirmações",
      "confirmations_other": "{{count}} confirmações",
      "explorer": "Explorer",
      "copy": "Copiar"
    },
    "details": {
      "title": "Dados do Certificado Verificado",
      "certificateInfo": "Informações do Certificado",
      "certificateId": "ID do Certificado",
      "student": "Estudante",
      "course": "Curso/Conteúdo",
      "issueDate": "Data de Emissão",
      "blockchainData": "Dados da Blockchain",
      "transactionHash": "Hash da Transação",
      "certificateHash": "Hash do Certificado",
      "block": "Bloco",
      "timestamp": "Timestamp"
    },
    "advanced": {
      "show": "Mostrar Informações Técnicas",
      "hide": "Ocultar Informações Técnicas",
      "network": "Rede",
      "gasUsed": "Gas Usado",
      "confirmations": "Confirmações",
      "about": "<bold>Sobre a Verificação Blockchain:</bold> Este certificado foi registrado de forma imutável na blockchain {{network}}. O hash único garante que o documento não pode ser falsificado ou alterado após a emissão."
    },
    "newVerification": "Nova Verificação",
    "howItWorks": {
      "title": "Como funciona a verificação blockchain",
      "item1": "Cada certificado Xtreed é registrado na blockchain com um hash único",
      "item2": "O registro é imutável e permanente - não pode ser alterado ou falsificado",
      "item3": "A verificação é instantânea e funciona 24/7 em qualquer lugar do mundo",
      "item4": "Suportamos tanto Ethereum quanto Polygon para máxima compatibilidade"
    },
    "formats": {
      "dateTime": "dd/MM/yyyy HH:mm",
      "shortDateTime": "dd/MM HH:mm",
      "longDate": "dd 'de' MMMM 'de' yyyy"
    }
  },
  "gallery": {
    "toasts": {
      "loadError": "Erro ao carregar certificados",
      "downloadStarted": "Download iniciado!",
      "downloadError": "Erro ao baixar certificado",
      "sharedOnLinkedIn": "Compartilhado no LinkedIn!",
      "linkCopied": "Link copiado para área de transferência!",
      "shareError": "Erro ao compartilhar certificado"
    },
    "fileName": "certificado-{{id}}.pdf",
    "stats": {
      "total": "Total de Certificados",
      "modules": "Módulos Concluídos",
      "courses": "Cursos Completos",
      "tracks": "Trilhas Completas"
    },
    "types": {
      "module": "Módulo",
      "course": "Curso",
      "track": "Trilha"
    },
    "badges": {
      "physical": "Físico"
    },
    "menu": {
      "view": "Visualizar",
      "download": "Download",
      "share": "Compartilhar"
    },
    "issuedOn": "Emitido em {{date}}",
    "metrics": {
      "views": "Views",
      "downloads": "Downloads",
      "shares": "Shares"
    },
    "actions": {
      "view": "Ver",
      "download": "Download"
    },
    "title": "Meus Certificados",
    "found_one": "{{count}} certificado encontrado",
    "found_zero": "{{count}} certificados encontrados",
    "found_other": "{{count}} certificados encontrados",
    "searchPlaceholder": "Buscar certificados...",
    "filters": {
      "all": "Todos",
      "module": "Módulos",
      "course": "Cursos",
      "track": "Trilhas"
    },
    "sort": {
      "newest": "Mais recente",
      "oldest": "Mais antigo",
      "name": "Nome",
      "type": "Tipo"
    },
    "selected_one": "{{count}} certificado selecionado",
    "selected_zero": "{{count}} certificados selecionados",
    "selected_other": "{{count}} certificados selecionados",
    "batch": {
      "download": "Download em Lote",
      "share": "Compartilhar"
    },
    "loading": "Carregando certificados...",
    "empty": {
      "noResultsTitle": "Nenhum certificado encontrado",
      "noCertificatesTitle": "Você ainda não possui certificados",
      "noResultsDescription": "Tente ajustar os filtros de busca",
      "noCertificatesDescription": "Complete cursos e módulos para receber seus certificados profissionais",
      "exploreCourses": "Explorar Cursos"
    },
    "formats": {
      "date": "dd/MM/yyyy"
    }
  },
  "generatorV3": {
    "typeTitles": {
      "module": "CERTIFICADO DE MÓDULO",
      "course": "CERTIFICADO DE CONCLUSÃO",
      "track": "CERTIFICADO DE TRILHA",
      "default": "CERTIFICADO PROFISSIONAL"
    },
    "toasts": {
      "generatedTitle": "Certificado gerado com sucesso!",
      "generatedSharedOnLinkedIn": "Também foi compartilhado no seu LinkedIn!",
      "generatedReady": "Certificado pronto para download.",
      "viewAction": "Visualizar",
      "internalServerError": "Erro interno do servidor",
      "generateError": "Erro ao gerar certificado",
      "downloadStarted": "Download iniciado!",
      "downloadError": "Erro ao baixar certificado",
      "alreadyShared": "Certificado já foi compartilhado automaticamente!"
    },
    "fileName": "certificado-{{id}}.pdf",
    "completedOn": "Concluído em {{date}}",
    "tagline": "Xtreed - Plataforma de Desenvolvimento Profissional",
    "body": {
      "certifyThat": "Certificamos que",
      "completedModule": "concluiu com êxito o módulo",
      "completedTrack": "completou toda a trilha",
      "completedCourse": "concluiu com êxito o curso",
      "demonstrating": "demonstrando conhecimento e dedicação nos estudos"
    },
    "options": {
      "title": "Opções Avançadas",
      "qrCode": "QR Code de Verificação",
      "blockchain": "Registro Blockchain",
      "linkedin": "Compartilhar LinkedIn",
      "physicalDelivery": "Entrega Física"
    },
    "details": {
      "completionDate": "Data de Conclusão",
      "verificationCode": "Código de Verificação",
      "willBeGenerated": "Será gerado...",
      "onlineVerification": "Verificação Online",
      "available247": "Disponível 24/7"
    },
    "footer": {
      "validity": "Este certificado é válido e pode ser verificado através do QR Code e código únicos.",
      "blockchain": "Registro blockchain garante autenticidade e integridade do documento.",
      "copyright": "© {{year}} Xtreed. Todos os direitos reservados."
    },
    "actions": {
      "generating": "Gerando Certificado...",
      "generate": "Gerar Certificado Profissional",
      "success": "Certificado Gerado com Sucesso!",
      "downloadPdf": "Download PDF",
      "verify": "Verificar"
    },
    "formats": {
      "date": "dd/MM/yyyy",
      "longDate": "dd 'de' MMMM 'de' yyyy"
    }
  },
  "verificationV3": {
    "toasts": {
      "enterCode": "Digite o código de verificação",
      "successTitle": "Certificado verificado com sucesso!",
      "successDescription": "Documento autêntico e válido",
      "invalidTitle": "Certificado inválido",
      "error": "Erro na verificação",
      "linkCopied": "Link copiado!"
    },
    "unableToVerify": "Não foi possível verificar a autenticidade",
    "header": {
      "title": "Verificação de Certificado",
      "description": "Digite o código de verificação do certificado para validar sua autenticidade. Todos os certificados Xtreed são protegidos com blockchain e assinatura digital."
    },
    "form": {
      "title": "Verificar Certificado",
      "codeLabel": "Código de Verificação",
      "placeholder": "Ex: DCF-2024-ABCD-1234",
      "availability": "Verificação disponível 24/7 • Tecnologia blockchain"
    },
    "result": {
      "validTitle": "Certificado Válido ✓",
      "invalidTitle": "Certificado Inválido ✗",
      "validDescription": "Documento autêntico e verificado",
      "verifiedAt": "Verificado em {{date}}",
      "details": "Detalhes"
    },
    "info": {
      "title": "Informações do Certificado",
      "student": "Estudante",
      "course": "Curso/Conteúdo",
      "issueDate": "Data de Emissão",
      "type": "Tipo de Certificado",
      "types": {
        "module": "Módulo",
        "course": "Curso",
        "track": "Trilha"
      },
      "status": "Status: <active>Ativo</active>",
      "share": "Compartilhar"
    },
    "advanced": {
      "title": "Verificações de Segurança Avançadas",
      "checks": {
        "qrCode": "QR Code Válido",
        "digitalSignature": "Assinatura Digital",
        "blockchain": "Blockchain Verificado",
        "template": "Template Válido",
        "notRevoked": "Não Revogado",
        "withinValidity": "Dentro da Validade"
      },
      "maxSecurityTitle": "Segurança Máxima:",
      "maxSecurityDescription": "Este certificado utiliza múltiplas camadas de segurança incluindo blockchain, assinatura digital criptográfica e verificação em tempo real."
    },
    "warnings": "Avisos",
    "verifyAnother": "Verificar Outro Certificado",
    "formats": {
      "dateTime": "dd/MM/yyyy HH:mm",
      "longDate": "dd 'de' MMMM 'de' yyyy"
    }
  },
  "viewerV3": {
    "fileName": "certificado-{{id}}",
    "dialogDescription": "Visualização do certificado",
    "formats": {
      "date": "dd/MM/yyyy",
      "dateTime": "dd/MM/yyyy HH:mm"
    },
    "toasts": {
      "downloadStarted": "Download iniciado!",
      "downloadStartedDescription": "Certificado em PDF de alta qualidade",
      "downloadError": "Erro ao baixar certificado",
      "linkedInShared": "Compartilhado no LinkedIn!",
      "linkedInSharedDescription": "Certificado adicionado ao seu perfil",
      "viewPost": "Ver Post",
      "linkedInShareError": "Erro ao compartilhar no LinkedIn",
      "screenshotSaved": "Screenshot salva!",
      "screenshotError": "Erro ao capturar screenshot",
      "linkCopied": "Link copiado!",
      "linkCopiedDescription": "Link de verificação copiado para área de transferência",
      "comingSoon": "Em breve!",
      "physicalDeliveryComingSoon": "Funcionalidade de entrega física será disponibilizada em breve"
    },
    "info": {
      "student": "Estudante",
      "code": "Código",
      "issueDate": "Data de Emissão",
      "status": "Status"
    },
    "status": {
      "valid": "Válido",
      "revoked": "Revogado",
      "pending": "Pendente"
    },
    "metrics": {
      "views": "Visualizações",
      "downloads": "Downloads",
      "verifications": "Verificações",
      "shares": "Compartilhamentos"
    },
    "title": {
      "module": "Certificado de Módulo",
      "track": "Certificado de Trilha",
      "course": "Certificado de Conclusão"
    },
    "tabs": {
      "preview": "Preview",
      "details": "Detalhes",
      "sharing": "Compartilhar",
      "verification": "Verificação"
    },
    "preview": {
      "loading": "Carregando certificado...",
      "iframeTitle": "Preview do Certificado"
    },
    "details": {
      "contentInfo": "Informações do Conteúdo",
      "title": "Título",
      "description": "Descrição",
      "workload": "Carga Horária",
      "hours": "{{hours}}h",
      "skills": "Competências Certificadas",
      "security": "Segurança e Verificação",
      "validSignature": "Assinatura Digital Válida",
      "signedBy": "Assinado por {{issuer}} em {{date}}",
      "blockchainRegistered": "Registrado na Blockchain",
      "hash": "Hash: {{hash}}...",
      "viewOnBlockchain": "Ver na Blockchain →"
    },
    "qrCode": {
      "title": "QR Code de Verificação",
      "scanToVerify": "Escaneie para verificar autenticidade"
    },
    "physicalDelivery": {
      "requested": "Entrega Física Solicitada",
      "status": "Status:",
      "delivered": "Entregue",
      "shipped": "Enviado",
      "processing": "Em processamento",
      "trackingCode": "Código de rastreamento:",
      "requestProcessing": "Solicitação em processamento..."
    },
    "sharing": {
      "social": "Compartilhamento Social",
      "shareOnLinkedIn": "Compartilhar no LinkedIn",
      "copyVerificationLink": "Copiar Link de Verificação",
      "saveAsImage": "Salvar como Imagem",
      "sharedOnLinkedIn": "Compartilhado no LinkedIn",
      "sharedAt": "Em {{date}}",
      "copyLink": "Copiar Link"
    },
    "verification": {
      "title": "Verificação de Autenticidade",
      "publicLink": "Link Público de Verificação",
      "copy": "Copiar",
      "open": "Abrir",
      "code": "Código de Verificação",
      "codeHint": "Use este código no formulário de verificação",
      "howTo": "<bold>Como verificar:</bold> Qualquer pessoa pode verificar a autenticidade deste certificado usando o código ou link acima. A verificação inclui blockchain, assinatura digital e validações de integridade."
    },
    "footer": {
      "validId": "Certificado válido e verificável • ID: {{id}}...",
      "openInNewTab": "Abrir em Nova Aba",
      "downloadPdf": "Download PDF",
      "requestPhysical": "Solicitar Físico"
    }
  },
  "linkedIn": {
    "defaults": {
      "headline": "Aluno Xtreed",
      "module": {
        "title": "🎓 Módulo Concluído: {title}",
        "description": "Acabei de concluir o módulo \"{title}\" na Xtreed! Mais um passo na minha jornada de desenvolvimento profissional. 💻✨",
        "hashtags": "#Xtreed, #Aprendizado, #Conhecimento, #Certificado"
      },
      "course": {
        "title": "🏆 Curso Completo: {title}",
        "description": "Certificado conquistado! Concluí com sucesso o curso \"{title}\" na Xtreed. Conhecimento adquirido e pronto para novos desafios! 🚀",
        "hashtags": "#Xtreed, #CertificadoProfissional, #Aprendizado, #Carreira"
      },
      "track": {
        "title": "🎯 Trilha Completa: {title}",
        "description": "Missão cumprida! Finalizei toda a trilha \"{title}\" na Xtreed. Uma jornada completa de aprendizado e crescimento profissional! 🌟",
        "hashtags": "#Xtreed, #TrilhaCompleta, #Formação, #Carreira"
      }
    },
    "toasts": {
      "comingSoon": "Em breve!",
      "comingSoonDescription": "Integração com LinkedIn será disponibilizada em breve",
      "connected": "Conectado ao LinkedIn!",
      "connectError": "Erro ao conectar com LinkedIn",
      "disconnected": "Desconectado do LinkedIn",
      "disconnectError": "Erro ao desconectar",
      "saved": "Configurações salvas!",
      "saveError": "Erro ao salvar configurações"
    },
    "templateEditor": {
      "postTitle": "Título do Post",
      "postTitlePlaceholder": "Ex: 🎓 Módulo Concluído: {title}",
      "titleHint": "Use {title} para inserir o nome do certificado automaticamente",
      "description": "Descrição",
      "descriptionPlaceholder": "Descreva sua conquista...",
      "hashtags": "Hashtags",
      "hashtagsPlaceholder": "#Xtreed, #Aprendizado, #Certificado",
      "hashtagsHint": "Separe as hashtags por vírgula"
    },
    "post": {
      "now": "Agora",
      "professionalCertificate": "CERTIFICADO PROFISSIONAL",
      "like": "👍 Curtir",
      "comment": "💬 Comentar",
      "repost": "🔄 Repostar",
      "send": "📤 Enviar"
    },
    "header": {
      "title": "Integração LinkedIn",
      "subtitle": "Configure o compartilhamento automático dos seus certificados no LinkedIn. Adicione credibilidade ao seu perfil profissional e celebre suas conquistas!"
    },
    "connection": {
      "connectedTitle": "LinkedIn Conectado",
      "connectTitle": "Conectar ao LinkedIn",
      "connectedAs": "Conectado como {{name}}",
      "connectDescription": "Conecte sua conta para compartilhar certificados automaticamente",
      "viewProfile": "Ver Perfil",
      "disconnect": "Desconectar",
      "connect": "Conectar LinkedIn"
    },
    "profile": {
      "name": "Nome:",
      "headline": "Headline:",
      "publicProfile": "Perfil Público:"
    },
    "tabs": {
      "settings": "Configurações",
      "templates": "Templates",
      "preview": "Preview"
    },
    "settings": {
      "title": "Configurações de Compartilhamento",
      "enable": "Ativar Integração",
      "enableDescription": "Permite que a Xtreed publique em seu LinkedIn",
      "autoShare": "Compartilhamento Automático",
      "autoShareDescription": "Publica automaticamente quando você recebe um certificado",
      "postSettings": "Configurações do Post",
      "includeImage": "Incluir Imagem do Certificado",
      "includeImageDescription": "Anexa preview visual",
      "includeDescription": "Incluir Descrição Detalhada",
      "includeDescriptionDescription": "Adiciona texto descritivo",
      "addToEducation": "Adicionar à Seção Educação",
      "addToEducationDescription": "Aparece na linha do tempo",
      "addToCertifications": "Adicionar às Certificações",
      "addToCertificationsDescription": "Seção de licenças e certificações",
      "visibility": "Visibilidade dos Posts",
      "public": "Público",
      "connections": "Conexões",
      "private": "Privado"
    },
    "templates": {
      "modules": "Módulos",
      "tracks": "Trilhas",
      "courses": "Cursos",
      "hidePreview": "Ocultar Preview",
      "showPreview": "Visualizar Preview"
    },
    "preview": {
      "sampleTitle": "React.js Completo - Do Básico ao Avançado",
      "title": "Preview dos Posts",
      "description": "Veja como seus certificados aparecerão no LinkedIn",
      "testTitle": "Título do Certificado (para teste)",
      "testTitlePlaceholder": "Nome do curso ou módulo",
      "module": "Módulo",
      "course": "Curso",
      "track": "Trilha"
    },
    "permissions": {
      "title": "Sobre as Permissões",
      "description": "A Xtreed utiliza a API oficial do LinkedIn com permissões limitadas e seguras. Nunca faremos posts sem sua autorização prévia e você pode desconectar a qualquer momento."
    },
    "unsaved": {
      "title": "Alterações não salvas",
      "description": "Suas configurações foram modificadas",
      "save": "Salvar"
    }
  },
  "physicalDelivery": {
    "formats": {
      "date": "dd/MM/yyyy",
      "dateTime": "dd/MM/yyyy HH:mm"
    },
    "zipCodeLine": "CEP: {{zipCode}}",
    "shipping": {
      "standard": {
        "name": "Padrão",
        "description": "Entrega econômica via Correios"
      },
      "express": {
        "name": "Expresso",
        "description": "Entrega rápida com SEDEX"
      },
      "premium": {
        "name": "Premium",
        "description": "Entrega especial com embalagem deluxe"
      },
      "features": {
        "premiumPaper": "Certificado em papel premium",
        "protectiveEnvelope": "Envelope protetor",
        "basicTracking": "Rastreamento básico",
        "fullTracking": "Rastreamento completo",
        "insuranceIncluded": "Seguro incluso",
        "specialPaper": "Certificado em papel especial 300g",
        "premiumBox": "Caixa premium Xtreed",
        "customEnvelope": "Envelope personalizado",
        "authenticitySeal": "Selo de autenticidade",
        "realTimeTracking": "Rastreamento em tempo real",
        "fullInsurance": "Seguro total",
        "signatureDelivery": "Entrega com assinatura"
      },
      "businessDays_one": "{{count}} dia útil",
      "businessDays_zero": "{{count}} dias úteis",
      "businessDays_other": "{{count}} dias úteis",
      "title": "Escolha o Método de Envio",
      "summary": "Resumo do Frete",
      "method": "Método:",
      "cost": "Valor:",
      "deadline": "Prazo:"
    },
    "toasts": {
      "loadError": "Erro ao carregar informações de entrega",
      "requiredFields": "Preencha todos os campos obrigatórios",
      "requested": "Entrega física solicitada!",
      "estimatedDelivery": "Estimativa de entrega: {{date}}",
      "requestError": "Erro ao solicitar entrega física",
      "codeCopied": "Código copiado!"
    },
    "progress": {
      "pending": "Solicitado",
      "processing": "Processando",
      "shipped": "Enviado",
      "delivered": "Entregue"
    },
    "tracking": {
      "title": "Rastreamento de Entrega - {{title}}",
      "loading": "Carregando informações...",
      "orderInfo": "Informações do Pedido",
      "certificate": "Certificado:",
      "status": "Status:",
      "delivered": "Entregue",
      "shipped": "Enviado",
      "processing": "Em processamento",
      "requestedAt": "Solicitado em:",
      "deliveryAddress": "Endereço de Entrega",
      "trackingCode": "Código de Rastreamento",
      "copy": "Copiar",
      "track": "Rastrear",
      "latestUpdates": "Últimas Atualizações",
      "refresh": "Atualizar Status"
    },
    "header": {
      "title": "Entrega Física do Certificado",
      "subtitle": "Receba seu certificado impresso em casa com qualidade profissional. Papel premium, embalagem especial e entrega rastreada em todo o Brasil."
    },
    "form": {
      "title": "Dados para Entrega",
      "personalInfo": "Informações Pessoais",
      "fullName": "Nome Completo *",
      "fullNamePlaceholder": "Nome como deve aparecer na entrega",
      "phone": "Telefone *",
      "email": "E-mail *",
      "emailPlaceholder": "seu@email.com",
      "address": "Endereço de Entrega",
      "zipCode": "CEP *",
      "street": "Rua/Avenida *",
      "streetPlaceholder": "Nome da rua",
      "number": "Número *",
      "complement": "Complemento",
      "complementPlaceholder": "Apto 45",
      "neighborhood": "Bairro *",
      "neighborhoodPlaceholder": "Nome do bairro",
      "city": "Cidade *",
      "cityPlaceholder": "Sua cidade",
      "state": "Estado *",
      "statePlaceholder": "UF",
      "country": "País",
      "countryValue": "Brasil",
      "specialInstructions": "Instruções Especiais",
      "specialInstructionsPlaceholder": "Observações para o entregador (opcional)"
    },
    "actions": {
      "continue": "Continuar",
      "back": "Voltar"
    },
    "confirmation": {
      "title": "Confirmação do Pedido",
      "certificateToSend": "Certificado a ser Enviado",
      "titleLabel": "Título:",
      "idLabel": "ID:",
      "issuedAt": "Emitido em:",
      "deliveryData": "Dados de Entrega",
      "name": "Nome:",
      "phone": "Telefone:",
      "email": "E-mail:",
      "address": "Endereço:",
      "financialSummary": "Resumo Financeiro",
      "certificate": "Certificado:",
      "free": "Gratuito",
      "shipping": "Frete ({{method}}):",
      "total": "Total:",
      "paymentInfo": "<bold>Sobre o Pagamento:</bold> O valor do frete será cobrado apenas no momento do envio. Você receberá um link de pagamento quando o certificado estiver pronto para envio.",
      "confirm": "Confirmar Pedido"
    }
  },
  "templateEditor": {
    "title": {
      "create": "Criar Template",
      "edit": "Editar Template",
      "view": "Visualizar Template"
    },
    "dialogDescription": "Configure o template de certificado",
    "unsaved": "Não salvo",
    "actions": {
      "edit": "Editar",
      "preview": "Preview",
      "save": "Salvar"
    },
    "toasts": {
      "nameRequired": "Nome e nome de exibição são obrigatórios",
      "created": "Template criado!",
      "updated": "Template atualizado!",
      "saveError": "Erro ao salvar template"
    },
    "tabs": {
      "general": "Geral",
      "design": "Design",
      "elements": "Elementos",
      "advanced": "Avançado"
    },
    "general": {
      "title": "Informações Básicas",
      "nameLabel": "Nome do Template *",
      "namePlaceholder": "Nome interno",
      "displayNameLabel": "Nome de Exibição *",
      "displayNamePlaceholder": "Nome visível para usuários",
      "descriptionLabel": "Descrição",
      "descriptionPlaceholder": "Descrição do template",
      "typeLabel": "Tipo de Certificado",
      "types": {
        "module": "Módulo",
        "course": "Curso",
        "track": "Trilha"
      },
      "designVariantLabel": "Variante de Design"
    },
    "designVariants": {
      "minimal": {
        "label": "Minimalista",
        "description": "Design limpo e moderno"
      },
      "classic": {
        "label": "Clássico",
        "description": "Estilo tradicional e elegante"
      },
      "modern": {
        "label": "Moderno",
        "description": "Visual contemporâneo"
      },
      "premium": {
        "label": "Premium",
        "description": "Design luxuoso com acabamentos"
      },
      "elite": {
        "label": "Elite",
        "description": "Máximo nível de sofisticação"
      }
    },
    "design": {
      "colorsTitle": "Cores do Template",
      "colorKeys": {
        "primary": "primary",
        "secondary": "secondary",
        "accent": "accent",
        "text": "text",
        "background": "background"
      },
      "presetColors": "Cores Predefinidas",
      "typographyTitle": "Tipografia",
      "fontKeys": {
        "primary": "primary",
        "secondary": "secondary",
        "accent": "accent"
      }
    },
    "elements": {
      "title": "Elementos do Template",
      "add": "Adicionar",
      "addDialogTitle": "Adicionar Elemento",
      "addDialogDescription": "Selecione um tipo de elemento para adicionar ao template",
      "emptyTitle": "Nenhum elemento adicionado ainda",
      "emptyDescription": "Clique em \"Adicionar\" para começar"
    },
    "elementTypes": {
      "text": {
        "label": "Texto",
        "description": "Adicionar texto dinâmico"
      },
      "image": {
        "label": "Imagem",
        "description": "Inserir logo ou imagem"
      },
      "background": {
        "label": "Fundo",
        "description": "Cor ou gradiente de fundo"
      },
      "border": {
        "label": "Borda",
        "description": "Molduras decorativas"
      },
      "qrCode": {
        "label": "QR Code",
        "description": "Código de verificação"
      },
      "signature": {
        "label": "Assinatura",
        "description": "Assinatura digital"
      }
    },
    "element": {
      "name": "Nome",
      "zIndex": "Z-Index",
      "x": "X (mm)",
      "y": "Y (mm)",
      "width": "Largura",
      "height": "Altura",
      "content": "Conteúdo",
      "variable": "Variável",
      "fontSize": "Tamanho da Fonte",
      "color": "Cor",
      "imageUrl": "URL da Imagem"
    },
    "advanced": {
      "printSpecsTitle": "Especificações de Impressão",
      "dpi": "DPI",
      "colorMode": "Modo de Cor"
    },
    "preview": {
      "title": "Preview",
      "simplified": "Preview simplificado",
      "dimensions": "Dimensões: {{width}}x{{height}}mm",
      "elementsCount_one": "Elementos: {{count}}",
      "elementsCount_zero": "Elementos: {{count}}",
      "elementsCount_other": "Elementos: {{count}}"
    }
  }
}
